/**
 *Created by jmmartinez on 3/8/18
 * v.1.1  28/03/2019 Añadido tipo "PREGUNTA. Añadidos prop onAccept y botones aceptar/cancelar para las preguntas.
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  28/12/2020 Añadido tipo PREGUNATASINO.
 *                   Modificado render para hacer dinámico el texto de los botones aceptar y cancelar
 * v.2.2  27(04/2021 Modificado el aspecto de los botones.
 * v.2.3  07/09/2021 Añadida propiedad textoHTML
 *                   Según el valor de esta propiedad, en el render se pone el texto directamente o se llama a <div dangerouslySetInnerHTML={{__html: mensaje}}/>
 * v.2.4 03/05/2022  Unión Sidemur - Planifikator
 **/

import React from 'react'
import { Dialog, Tooltip, Button, Intent } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import {Classes} from "@blueprintjs/core/lib/esm/index";


class Dialogo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            titulo: props.titulo,
            mensaje: props.mensaje,
            tipo: props.tipo,
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.titulo !== prevState.titulo) {
            newState.titulo = nextProps.titulo;
        }
        if (nextProps.mensaje !== prevState.mensaje) {
            newState.mensaje = nextProps.mensaje;
        }
        if (nextProps.tipo !== prevState.tipo) {
            newState.tipo = nextProps.tipo;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onClose= () => {
        console.log("onClose");
        const {onClose} = this.props;
        this.setState({mensaje: null});
        onClose && onClose();
    }

    onQuestion= (respuesta) => {
        const {onQuestion} = this.props;
        this.setState({mensaje: null});
        onQuestion && onQuestion(respuesta);
    }

    render() {
        const {mensaje, tipo, titulo} =  this.state;
        const {onQuestion, textHTML,
            tituloAccion1, iconoAccion1, onBotonAccion1} = this.props;
        let tituloTransformado= titulo ? titulo : ""; //PAra evitar el warning con icon
        let icon= "info-sign";
        let color= "#dddddd";
        let textoAceptar= "Aceptar";
        let textoCancelar= "Cancelar";

        //console.log("DIALOGO - RENDER");
        //console.log("tipo: ", tipo);

        switch (tipo){
            case "INFORMACION": icon= "info-sign"; color= "#dddddd"; break;
            case "EXITO": icon= "tick-circle"; color="#b2ddc6"; break;
            case "ERROR": icon= "error"; color="#F8B87D"; break;
            case "PREGUNTA": icon= "help"; color="#ffffff"; break;
            case "PREGUNTASINO": textoAceptar="  Sí  "; textoCancelar="No"; icon= "help";
            default: icon= "info-sign"; color= "#dddddd"; break;
        }
        let mostrarHTML= textHTML && Boolean(textHTML);

        //console.log("Texto Aceptar: ", textoAceptar);
        //console.log("Texto Cancelar: ", textoCancelar);

        return (
            <Dialog icon={icon}
                    title={tituloTransformado}
                    onClose={this.onClose}
                    isOpen={mensaje && mensaje !== ""}
                    usePortal= {true}
                    style={{ width: "60%", backgroundColor: color}}
            >
                <div className={Classes.DIALOG_BODY}>
                    {mostrarHTML &&
                    <div dangerouslySetInnerHTML={{__html: mensaje}}/>
                    }
                    {!mostrarHTML &&
                    <div>{mensaje}</div>
                    }
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    {!onQuestion &&
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            {tituloAccion1 &&
                            <Button icon={iconoAccion1} style={{marginRight: 10}} text={tituloAccion1} onClick={() => onBotonAccion1 && onBotonAccion1()} />
                            }
                            <Tooltip content="Cerrar">
                                <Button onClick={this.onClose}>Cerrar</Button>
                            </Tooltip>
                        </div>
                    }
                    {onQuestion &&
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content={textoAceptar}>
                                <Button icon="confirm" style={{width: 100}} large={true} intent={Intent.SUCCESS} text={textoAceptar} onClick={() => this.onQuestion(true)} />
                            </Tooltip>
                            <Tooltip content={textoCancelar}>
                                <Button icon="disable" style={{width: 100}} large={true} intent={Intent.DANGER} text={textoCancelar} onClick={() => this.onQuestion(false)} />
                            </Tooltip>
                        </div>
                    }
                </div>
            </Dialog>
        );
    }
}


Dialogo.propTypes = {
    titulo: PropTypes.string,
    mensaje: PropTypes.string,
    tipo: PropTypes.string,
    onClose: PropTypes.func,
    onQuestion: PropTypes.func,
    textHTML: PropTypes.bool,

    tituloAccion1: PropTypes.string,
    iconoAccion1: PropTypes.string,
    onBotonAccion1: PropTypes.func,
}

export default Dialogo

